var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVegetables46 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "760.614px",
    height: "674.85px",
    viewBox: "0 0 760.614 674.85",
    enableBackground: "new 0 0 760.614 674.85",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M619.156,44.543c34.55,20.466,114.912,3.495,136.708,38.098 c18.021,28.525-21.449,104.252-15.943,136.736c11.969,70.699-0.866,134.16-28.231,189.984 c-72.789,148.404-234.479,250.953-397.779,264.253c-106.21,8.624-186.647-28.274-248.398-98.749 c-109.74-125.264-87.245-355.428,110.364-482.83C302.035,12.413,471.415-43.084,619.156,44.543L619.156,44.543z M114.231,230.338 c-23.999,58.01-42.375,138.876-32.3,196.651l72.923,2.479c14.13-52.273,30.303-82.983,49.247-121.428 C167.782,286.386,137.621,260.635,114.231,230.338L114.231,230.338z M600.525,194.653c0,90.874,0,181.724,0,272.58 c58.002-63.26,86.826-152.364,57.778-292.669C639.037,181.272,619.773,187.987,600.525,194.653L600.525,194.653z M147.851,462.567 l-56.803-1.958c11.172,29.068,30.303,52.593,59.442,66.104C144.736,507.217,144.51,485.364,147.851,462.567z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVegetables46, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vegetables-46.b3a0c57e.svg";
export { ForwardRef as ReactComponent };